import { Component } from '@angular/core';

interface ServiceDetail {
  image: string;
  titleKey: string;
  leadKey: string;
  featureKeys: string[];
  altKey: string;
}

@Component({
  selector: 'app-services-page',
  templateUrl: './services-page.component.html',
  styleUrls: ['./services-page.component.scss']
})
export class ServicesPageComponent {
  readonly services: ServiceDetail[] = [
    {
      image: 'assets/images/vagott-virag.jpg',
      titleKey: 'pages.services.items.cut.title',
      leadKey: 'pages.services.items.cut.lead',
      featureKeys: [
        'pages.services.items.cut.feature1',
        'pages.services.items.cut.feature2',
        'pages.services.items.cut.feature3'
      ],
      altKey: 'pages.services.items.cut.alt'
    },
    {
      image: 'assets/images/tavaszi_csokor.jpg',
      titleKey: 'pages.services.items.bouquet.title',
      leadKey: 'pages.services.items.bouquet.lead',
      featureKeys: [
        'pages.services.items.bouquet.feature1',
        'pages.services.items.bouquet.feature2',
        'pages.services.items.bouquet.feature3'
      ],
      altKey: 'pages.services.items.bouquet.alt'
    },
    {
      image: 'assets/images/orchidea.jpg',
      titleKey: 'pages.services.items.potted.title',
      leadKey: 'pages.services.items.potted.lead',
      featureKeys: [
        'pages.services.items.potted.feature1',
        'pages.services.items.potted.feature2',
        'pages.services.items.potted.feature3'
      ],
      altKey: 'pages.services.items.potted.alt'
    }
  ];
}
